import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {connect} from 'react-redux';
import Skeleton from '@material-ui/lab/Skeleton';
import {Icon} from 'front-onceforall-core';
import {ProjectDossierStatsContext} from '../../views/projectDetails/ProjectDetailsView';
import authenticationService from '../../services/authentication/AuthenticationService';
import documentService from '../../services/document/DocumentService';
import {openOrSaveFile} from '../../utils/http';

export const ProjectStatsQuitus = props => {
  const handleDownloadProjectOverviewReport = () => {
    authenticationService.authRedirect(
      documentService.getProjectOverviewReportDownloadUrl(
        props.myIntervention.interventionId,
        props.currentLocale
      )
    )
      .then(authUrl => openOrSaveFile(authUrl));
  };

  const renderLoading = () => (
    <div className="flex-container column center w-100">
      <Skeleton
        variant="rect"
        height={62}
        width={41}
      />
      <div className="w-100">
        <Skeleton variant="text"/>
      </div>
    </div>
  );

  const renderStats = (percentage, error, loading) => {
    if (error) {
      return <Translate value={error}/>;
    }

    if (loading) {
      return renderLoading();
    }

    let containerClass = 'warning';

    if (percentage === 0) {
      containerClass = 'error';
    }

    if (percentage >= 100) {
      containerClass = 'success';
    }

    return (
      <div className="simple-number-stats mb-5">
        <div className={`number ${containerClass}`}>{percentage}%</div>
        <div className="label"><Translate value="project.quitusDescription"/></div>
      </div>
    );
  };

  return (
    <ProjectDossierStatsContext.Consumer>
      {value => (
        <div className="card">
          <div className="card-header">
            <div className="card-title"><Translate value="project.quitus"/></div>
          </div>
          <div
            className="flex-container column center space-between"
            style={{height: 'calc(100% - 48px)'}}
          >
            {renderStats(value.validProjectDossierStates.percentage, value.validProjectDossierStates.error, value.validProjectDossierStates.loading)}
            <button
              data-id="download-project-overview-report"
              type="button"
              className="large link inline-container mt-5"
              onClick={handleDownloadProjectOverviewReport}
            >
              <Icon icon="download"/>
              <Translate value="project.exportQuitus"/>
            </button>
          </div>
        </div>
      )}
    </ProjectDossierStatsContext.Consumer>
  );
};

ProjectStatsQuitus.propTypes = {
  myIntervention: PropTypes.object.isRequired,
  organisation: PropTypes.object.isRequired,
  currentLocale: PropTypes.string.isRequired
};

function mapStateToProps(state) {
  return {
    organisation: state.organisation,
    currentLocale: state.i18n.locale
  };
}

export default connect(mapStateToProps)(ProjectStatsQuitus);
